<script>
import { fandomTranslate } from "src/modules/common_module";

export default {
  props: {
    message: {
      type: String,
      required: true
    }
  },
  mounted() {
    Vue.nextTick(() => {
      $('#modal-warning').modal({backdrop: 'static', keyboard: false});
    });
  },
  data: function() {
    return { };
  },
  methods: {
    ft: fandomTranslate,
    close(event) {
      $('#modal-warning').modal('hide');
      Vue.nextTick(() => {
        this.$emit(event);
      })
    }
  },
  computed: { }
};
</script>

<template>
  <div modal-warning-component>
    <div id="modal-warning" class="modal fade" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body text-center px-5 pb-5 pt-4">
            <div class="row justify-content-center">
              <div class="col-12 text-center">
                <h3 class="font-weight-normal text-gray-900">{{ft('globals.warning')}}</h3>
                <div class="font-weight-normal text-gray-900 small mb-4 pb-md-3" v-html="message"></div>
                <div class="w-100 d-flex justify-content-between">
                  <button class="btn btn-outline-dark mr-2" @click="close('cancel')">{{ft('globals.cancel')}}</button>
                  <button class="btn btn-primary ml-2" @click="close('confirm')">{{ft('globals.confirm')}}</button>
                </div>
              </div>
            </div>  
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
[modal-warning-component] {

}
</style>